const FlightSearchContants = {
  FETCH_FLIGHT_RESULTS: "flightSearchApp/FETCH_FLIGHT_RESULTS",
  FETCH_FLIGHT_RESULTS_COMPLETE: "flightSearchApp/FETCH_FLIGHT_RESULTS_COMPLETE",
  UPDATE_FILTERS: "flightSearchApp/UPDATE_FILTERS",
  SET_FLIGHT_SEARCH_CONTEXT: "flightSearchApp/SET_FLIGHT_SEARCH_CONTEXT",
  SET_PARTIAL_FLIGHT_SEARCH_CONTEXT: "flightSearchApp/SET_PARTIAL_FLIGHT_SEARCH_CONTEXT"
};
export {
  FlightSearchContants as default
};
//# sourceMappingURL=FlightSearchConstants.js.map
